import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CoreFeature from './CoreFeature';

function Chat() {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);



	return (

		<>
			<Helmet>
				<title>Efficient and Organized Team Chat Management | Taskflier</title>
			</Helmet>
				<div class="block-style-thirtySix bg-white lg-container pt-110 " id="feature">
					<div class="container">
						<div class="row">
							<div class="col-xl-6 col-lg-7  aos-init aos-animate" data-aos="fade-left">
								
									<div class="title-style-fourteen">
										<h6><span class="upper-title custom-name">Team Chat</span></h6>
										<h1>For seamless collaboration and always-on connectivity</h1>
									</div>
									<div class="tag-line">Effective communication is the key to successful teamwork. TaskFlier's Team Chat feature makes communication and collaboration extremely effective by providing instant real-time messaging feature that keeps your entire team in sync, whether they work remotely or in the office.</div>

								
							</div>
							<div class="col-xl-6 col-lg-5 text-center text-lg-left  aos-init aos-animate" data-aos="fade-right">
								<div class="illustration-holder d-inline-block md-mt-60">
									<img src="/main/images/dashboard.png" alt="" class="w-100" />
									<img src="/images/assets/ils_23.1.svg" alt="" class="shapes shape-one" />
									<img src="/images/assets/ils_23.2.svg" alt="" class="shapes shape-two" />
									<img src="/images/assets/ils_23.3.svg" alt="" class="shapes shape-three" />
								</div>
							</div>
						</div>
					</div>
				</div>

				  <div class="fancy-feature-ten pt-80 pb-80 bg-white" id="feature">
          <div class="bg-wrapper pt-80">
            <div class="container">

              <div class="row align-items-center">
<div class="col-lg-6 ">
                  <div
                    class="screen-holder-two aos-init aos-animate"
                    data-aos="fade-left"
                    data-aos-duration="1200"
                  >
                    <img src="/main/images/marketing-why.png" alt="Client Management" />
                  </div>
                </div>
                <div class="col-lg-5 offset-lg-1 aos-init aos-animate">
                  <div class="text-wrapper">

                    <h3 class="maintitle">Why TaskFlier’s Team Chat?</h3>
                    <p className="mainp">
                    TaskFlier's Team Chat feature acts as the central hub for all team conversations. It helps reduce email clutter, speeds  communication and promote collaboration whether it is quick updates or in-depth project discussions. This feature allows teams to work together smoothly and efficiently.
                    </p>

                  </div>
                </div>

                

              </div>


            </div>
           
          </div>
        </div>

				<div class="fancy-feature-thirtyFour pt-80 pb-100 bg-gray">
					<div class="container">
						<div class="title-style-two text-center mb-40 md-mb-40">
							<h6><span class="upper-title custom-name">Explore Taskflier Features!</span></h6>


							<div class="sub-text mt-0 pt-3 maxsubtitle">Frequent difficulties encountered in the software sector.
								Obstacles are a part of every project. But which ones affect software development?
							</div>
						</div>

						<div class="row  features">


							<div class="col-lg-4 col-12 ">

								<div class="Solutions-box " >
									<img src="/main/images/task-creation.png" alt="Task creation" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Instant Messaging for Real-Time Communication</div>
									<hr></hr>
									<p className="mainp">Exchange messages right away to people or groups, permitting instant remarks and speedy choice-making. Keep all people updated with short messages, reducing the need for prolonged emails or meetings.</p>


								</div>

							</div>
							<div class="col-lg-4 col-12 ">

								<div class="Solutions-box " >
									<img src="/main/images/customizing-taskboard.png" alt="Customizing taskboard" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Project-Specific Chat Rooms
									</div>
									<hr></hr>
									<p className="mainp">Create dedicated chat rooms for each undertaking or project, maintaining conversations targeted and private. Reduce distractions and make it easy for group participants to find applicable statistics and stay on topic.</p>

								</div>

							</div>
							<div class="col-lg-4 col-12 ">

								<div class="Solutions-box " >
									<img src="/main/images/task-dependencies.png" alt="Task dependencies" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Personal and Group Discussions</div>
									<hr></hr>
									<p className="mainp">Connect one-on-one with the team members for a quick check-in or open group chat for collaborative discussions. Add or remove members from group conversations with great ease, so that everyone involved can receive information and participate actively.</p>


								</div>
							</div>
							<div class="col-lg-4 col-12 ">

								<div class="Solutions-box " >
									<img src="/main/images/task-creation.png" alt="Task creation" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Sharing files and attachments</div>
									<hr></hr>
									<p className="mainp">Share files, documents and photos directly into conversations. To provide team members with access to valuable resources keep all inter-project files in one place, so that members can easily refer to it without switching between applications.</p>


								</div>

							</div>
							<div class="col-lg-4 col-12 ">

								<div class="Solutions-box " >
									<img src="/main/images/customizing-taskboard.png" alt="Customizing taskboard" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Message history and search
									</div>
									<hr></hr>
									<p className="mainp">A team member can access all team submission history. This ensures that important decisions and discussions are always available. Using a search engine to quickly find past conversations, files, or specific content saves time and effort.</p>

								</div>

							</div>
							<div class="col-lg-4 col-12 ">

								<div class="Solutions-box " >
									<img src="/main/images/task-dependencies.png" alt="Task dependencies" class="w-100" />
									<div class="pack-name mt-3 text-capitalize">Emojis and reactions</div>
									<hr></hr>
									<p className="mainp">Add emojis and reactions to messages to make conversations friendly and expressive. Embrace innovation, show support and maintain a positive team culture through fun, interactive communication.</p>


								</div>
							</div>



						</div>
					</div>
				</div>

   <div class="fancy-feature-ten pt-80 pb-80 Benefit  bg-white" id="feature">
            <div class="bg-wrapper pt-80">
              <div class="container">
                
              <div class="row align-items-center">
     
    
     
     <div class="col-lg-6 ">
       <div
         class="screen-holder-two aos-init aos-animate" data-aos-duration="1200">
         <img src="/main/images/enterprise-benefit.png" alt="Employee Lifecycle" />
       </div>
     </div>

	  <div class="col-lg-5 offset-lg-1 aos-init aos-animate">
       <div class="text-wrapper">
       
         <h3 class="maintitle mb-4">TaskFlier’s Team Chat brings cohesion into teams</h3>
        

     <p className="mainp">TaskFlier’s Team Chat feature helps teams connect, work, and organize from anywhere anytime. With real-time messaging capability, project-specific chat rooms and seamless file sharing, TaskFlier's Team Chat ensures that communication is always on so that teams may focus on what matters most, i.e., getting their job done.</p>

	 <Link class="theme-btn-2 mt-10 md-mt-30" to="/demo-request">Request Demo <i class="bi bi-arrow-right pl-2"></i></Link>

       </div>
     </div>
     
     </div>
     
               
              </div>
             
            </div> 
          </div>
				<CoreFeature />
				<div className="faq-classic pt-0 bg-white">
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<div className="title-style-one mb-40">
									<h6 className="font-rubik">Find your answers</h6>
									<h2>Have any thought? Look here.</h2>
								</div>
							</div>
							<div className="col-lg-12">
								<div id="accordion" className="md-mt-60">
									<div className="card">
										<div className="card-header" id="headingOne">
											<h5 className="mb-0">
												<button
													className="btn btn-link"
													data-bs-toggle="collapse"
													data-bs-target="#collapseOne"
													aria-expanded="true"
													aria-controls="collapseOne"
												>
													What is Team Chat?
												</button>
											</h5>
										</div>
										<div
											id="collapseOne"
											className="accordion-collapse collapse show"
											data-bs-parent="#accordion"
										>
											<div className="card-body">
												<p>
												Team Chat is a secure, real-time messaging platform designed to help your company streamline communication, enhance team collaboration, and centralize discussions—all in one place. It supports both 1-on-1 as well as group conversations with features tailored for professional use.
												</p>
											</div>
										</div>
									</div>
									<div className="card">
										<div className="card-header" id="headingTwo">
											<h5 className="mb-0">
												<button
													className="btn btn-link"
													data-bs-toggle="collapse"
													data-bs-target="#collapseTwo"
													aria-expanded="true"
													aria-controls="collapseTwo"
												>
													How is a Team Chat different from regular messaging apps?
												</button>
											</h5>
										</div>
										<div
											id="collapseTwo"
											className="accordion-collapse collapse "
											data-bs-parent="#accordion"
										>
											<div className="card-body">
												<p>
													Unlike consumer chat apps, a Team Chat is built for business. It offers advanced features like message encryption, file sharing, team channels, role-based access, chat history search, and integrations with your existing business tools.
												</p>
											</div>
										</div>
									</div>
									<div className="card">
										<div className="card-header" id="headingThree">
											<h5 className="mb-0">
												<button
													className="btn btn-link"
													data-bs-toggle="collapse"
													data-bs-target="#collapseThree"
													aria-expanded="true"
													aria-controls="collapseThree"
												>
													Does Team Chat support file sharing and document collaboration?
												</button>
											</h5>
										</div>
										<div
											id="collapseThree"
											className="accordion-collapse collapse"
											data-bs-parent="#accordion"
										>
											<div className="card-body">
												<p>
													Yes. You can easily share files, images, and documents within any chat. Files are stored securely and can be accessed or downloaded anytime. Integration with document tools allows for live collaboration as well.
												</p>
												
											</div>
										</div>
									</div>



									<div className="card">
										<div className="card-header" id="headingFour">
											<h5 className="mb-0">
												<button
													className="btn btn-link"
													data-bs-toggle="collapse"
													data-bs-target="#collapseFour"
													aria-expanded="true"
													aria-controls="collapseFour"
												>
													Is Team Chat secure?
												</button>
											</h5>
										</div>
										<div
											id="collapseFour"
											className="accordion-collapse collapse"
											data-bs-parent="#accordion"
										>
											<div className="card-body">
												<p>
													Yes. Team Chat uses end-to-end encryption, secure authentication, and role-based access control to protect your company’s data. Admins can also monitor activity and manage compliance settings as needed.
												</p>
												
											</div>
										</div>
									</div>


									<div className="card">
										<div className="card-header" id="headingFive">
											<h5 className="mb-0">
												<button
													className="btn btn-link"
													data-bs-toggle="collapse"
													data-bs-target="#collapseFive"
													aria-expanded="true"
													aria-controls="collapseFive"
												>
													Can we use Team Chat on mobile devices?
												</button>
											</h5>
										</div>
										<div
											id="collapseFive"
											className="accordion-collapse collapse"
											data-bs-parent="#accordion"
										>
											<div className="card-body">
												<p>
													Definitely. Team Chat can be accessed from any mobile device running on Android or iOS platform. It ensures seamless communication on the go with push notifications, offline access to recent messages, and mobile-optimized user experience.
												</p>
												
											</div>
										</div>
									</div>
									<div className="card">
										<div className="card-header" id="headingSix">
											<h5 className="mb-0">
												<button
													className="btn btn-link"
													data-bs-toggle="collapse"
													data-bs-target="#collapseSix"
													aria-expanded="true"
													aria-controls="collapseSix"
												>
													Is Team Chat suitable for remote or hybrid teams?
												</button>
											</h5>
										</div>
										<div
											id="collapseSix"
											className="accordion-collapse collapse"
											data-bs-parent="#accordion"
										>
											<div className="card-body">
												<p>
													Absolutely. Teams Chat is designed to keep remote, hybrid, and in-office teams connected. With instant messaging, status indicators, video call integration, and time zone tagging, your team stays productive from anywhere.
												</p>
												
											</div>
										</div>
									</div>

								</div>
							</div>
						</div>
					</div>
				</div>
		</>

	)
}

export default Chat
